module.exports = __webpack_public_path__ + "img/sjs.b2febdd5.png";